import { z } from "zod";

//#region src/hooks/form-validation/use-name-zod-schema.ts
const NAME_REGEX = /^([a-zA-Z0-9.\- "']|[à-ú]|[À-Ú])+$/;
const useNameZodSchema = () => {
	return z.string().trim().min(1).regex(NAME_REGEX);
};

//#endregion
export { useNameZodSchema };